import React from 'react';
import { Loader } from '../../../components/Loader';

export function ContactLeadFlowCard({
  refChain,
  refLoading,
  refError,
  editChainMode,
  setEditChainMode,
  chainDraft,
  setChainDraft,
  saveReferralChain,
  refSaveLoading,
  refSaveMsg,
  refSaveErr,
  contactList,
  currentId,
  navigate
}) {
  return (
    <div className="card h-100">
      <div className="card-header d-flex align-items-center justify-content-between">
        <h5 className="mb-0">Lead Generation Flow</h5>
        <div className="d-flex align-items-center gap-2">
          {refSaveErr ? (<span className="text-danger small">{refSaveErr}</span>) : null}
          {refSaveMsg ? (<span className="text-success small">{refSaveMsg}</span>) : null}
          {refLoading ? <Loader size="sm" /> : null}
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={() => setEditChainMode(v => !v)}
          >
            {editChainMode ? 'Close Editor' : 'Edit Chain'}
          </button>
        </div>
      </div>
      <div className="card-body">
        {editChainMode ? (
          <div className="mb-3 border rounded p-2">
            {chainDraft.map((cid, idx) => (
              <div key={idx} className="d-flex align-items-center gap-2 mb-2">
                <span className="badge bg-secondary">{idx + 1}</span>
                <select
                  className="form-select"
                  value={cid || ''}
                  onChange={(e) => {
                    const val = e.target.value;
                    setChainDraft(prev => {
                      const next = prev.slice();
                      next[idx] = val;
                      return next;
                    });
                  }}
                >
                  <option value="">Select contact...</option>
                  {(contactList || [])
                    .filter(c => c && c._id !== currentId)
                    .map(c => (
                      <option key={c._id} value={c._id}>
                        {c.contactName || c.contactPhone || c.contactEmail || String(c._id).slice(0,6)}
                      </option>
                    ))}
                </select>
                <button className="btn btn-outline-danger btn-sm" onClick={() => setChainDraft(prev => prev.filter((_, i) => i !== idx))}>
                  Remove
                </button>
              </div>
            ))}
            <div className="d-flex justify-content-between">
              <button className="btn btn-outline-primary btn-sm" onClick={() => setChainDraft(prev => [...prev, ''])}>Add Step</button>
              <button className="btn btn-success btn-sm" onClick={saveReferralChain} disabled={refSaveLoading}>
                {refSaveLoading ? 'Saving...' : 'Save Chain'}
              </button>
            </div>
          </div>
        ) : null}

        {refError && <div className="text-danger mb-2">{refError}</div>}
        {(!refChain || refChain.length === 0) ? (
          <div className="text-muted">No referrer recorded for this contact.</div>
        ) : (
          <ol className="list-group list-group-numbered">
            {(refChain || []).slice().reverse().map((p, idx) => (
              <li key={p._id} className="list-group-item d-flex justify-content-between align-items-start">
                <div className="ms-2 me-auto">
                  <button
                    type="button"
                    className="btn btn-link text-decoration-none p-0"
                    onClick={() => navigate(`/contact/${p._id}`)}
                  >
                    {p.contactName || p.contactPhone || p.contactEmail || (p._id || '').slice(0,6)}
                  </button>
                  <div className="small text-muted">
                    {(p.contactPhone || '-')}{p.contactEmail ? ` - ${p.contactEmail}` : ''}
                  </div>
                </div>
                {idx === 0 ? (
                  <span className="badge bg-secondary align-self-center">Origin</span>
                ) : (
                  <span className="text-muted align-self-center" aria-hidden="true">-&gt;</span>
                )}
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
}

